<template>
  <layout>
    <div>
      <b-card>
        <b-container>
          <b-row>
            <h4 class="card-title mb-0">Create Members</h4>
          </b-row>
          <br />
          <b-row>
            <b-col md="10">
              <b-form @submit.prevent="createMember" @reset="clearFields">
                <b-row>
                  <b-col>
                    <b-form-group
                      label="First Name"
                      label-for="groupSelect"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-input
                        id="brand"
                        type="text"
                        v-model="firstName"
                        placeholder="Enter First Name"
                        required
                        validate
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group
                      label="Last Name"
                      label-for="groupSelect"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-input
                        id="brand"
                        type="text"
                        v-model="lastName"
                        placeholder="Enter Last Name"
                        required
                        validate
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="NIC No"
                      label-for="groupSelect"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-input
                        id="brand"
                        type="text"
                        v-model="nic"
                        placeholder="Enter NIC Number"
                        required
                        validate
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Gender"
                      label-for="groupSelect"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-select
                        id="Gender"
                        ref="Gender"
                        v-model="gender"
                        class="form-control round"
                        validate
                        required
                      >
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Email ID"
                      label-for="email"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-input
                        id="email"
                        type="text"
                        v-model="email"
                        placeholder="Enter E-mail ID"
                        required
                        validate
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Body type"
                      label-for="bodytype"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-select
                        id="Gendbodytypeer"
                        ref="bodytype"
                        v-model="bodyType"
                        class="form-control round"
                        validate
                        required
                      >
                        <option value="null">Select Body Type</option>
                        <option value="male">Thin</option>
                        <option value="female">Fat</option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Mobile No"
                      label-for="groupSelect"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-input
                        id="brand"
                        type="number"
                        v-model="mobileNo"
                        placeholder="Ex : 077XXXXXXX"
                        required
                        validate
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Mobile No 2"
                      label-for="groupSelect"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-input
                        id="brand"
                        type="number"
                        v-model="mobileNo2"
                        placeholder="Ex : 077XXXXXXX"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label="Address"
                      label-for="groupSelect"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-textarea
                        id="textarea"
                        v-model="address"
                        placeholder="Enter address here"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label="Barcode"
                      label-for="groupSelect"
                      :label-cols="3"
                      :horizontal="true"
                    >
                      <b-form-input
                        id="barcode"
                        type="number"
                        v-model="barcode"
                        placeholder="Scan/Type Barcode"
                        required
                        validate
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-form-group>
                  <b-form-checkbox
                    v-model="status"
                    name="status"
                    value="Active"
                    unchecked-value="Inactive"
                    >Active</b-form-checkbox
                  >
                </b-form-group>
                <br />

                <div slot="footer">
                  <b-button
                    type="submit"
                    size="sm"
                    variant="primary"
                    class="mr-2"
                  >
                    <i class="fa fa-dot-circle-o" /> Submit
                  </b-button>
                  <b-button type="reset" size="sm" variant="danger">
                    <i class="fa fa-ban" /> Reset
                  </b-button>
                </div>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
    </div>
  </layout>
</template>
<script>
import Layout from '@layouts/main'
import uuidv4 from 'uuid/v4'

import { memberMethods } from '@state/helpers'
import { first } from 'lodash'

export default {
  name: 'newMembers',
  components: {
    Layout,
  },
  page: {
    title: 'Create Members',
  },
  computed: {},
  data() {
    return {
      firstName: '',
      lastName: '',
      address: '',
      mobileNo: null,
      mobileNo2: null,
      gender: null,
      nic: '',
      joined_date: '',
      last_payment_date: '',
      status: 'Active',
      email: '',
      barcode: '',
      bodyType: null,
      currentDate: new Date(),
    }
  },
  mounted() {},
  methods: {
    ...memberMethods,
    formattedDate() {
      const date = this.currentDate
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    async createMember() {
      let memberDetailsobj = {
        _id: 'member_' + uuidv4(),
        type: 'member',
        first_name: this.firstName,
        last_name: this.lastName,
        address: this.address,
        nic_no: this.nic,
        gender: this.gender,
        mobile_no: this.mobileNo,
        mobile_no_2: this.mobileNo2,
        email: this.email,
        body_type: this.bodyType,
        barcode: this.barcode,
        joined_date: this.formattedDate(),
        last_payment_date: '',
        next_payment_date: '',
        status: this.status,
      }

      let resp = await this.createMembers({ memberDetails: memberDetailsobj })
      if (resp.ok) {
        alert('Member added successfully')
        this.$router.push('/member')
      } else {
        alert('Member adding failed')
      }
    },
    clearFields() {
      this.firstName = ''
      this.lastName = ''
      this.address = ''
      this.mobileNo = null
      this.mobileNo2 = null
      this.email = ''
      this.body_type = null
      this.gender = null
      this.nic = ''
      this.joined_date = ''
      this.last_payment_date = ''
      this.barcode = ''
      this.status = 'Active'
    },
  },
}
</script>
